<template>
  <div class="body">
    <div class="title">
      <div>基本信息</div>
    </div>
    <a-form class="form" :form="form">
      <a-form-item label="头像">
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :customRequest="uploadHeadPic"
        >
          <img
            style="width: 100px; height: 140px"
            v-if="img_avatar_full"
            :src="img_avatar_full"
            alt="avatar"
          />
          <img
            class="notChoose"
            src="../../assets/images/expert/zjk-Upload avatar@2x.png"
            v-else
          />
        </a-upload>
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="姓名">
            <a-input
              style="width: 400px"
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入姓名!',
                    },
                    { validator: notNum, trigger: 'blur' },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="艺名/笔名">
            <a-input
              style="width: 400px"
              v-decorator="[
                'stage_name',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入艺名/笔名!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="性别">
        <a-radio-group
          v-decorator="[
            'sex',
            {
              initialValue: 1,
            },
          ]"
          name="radioGroup"
          :initialValue="1"
        >
          <a-radio :value="1">男</a-radio>
          <a-radio :value="0">女</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="民族">
            <a-select
              v-decorator="[
                'nation',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择民族!',
                    },
                  ],
                },
              ]"
              style="width: 240px"
            >
              <a-select-option
                v-for="(nation_item, nation_index) in nation"
                :key="nation_index"
                :value="nation_item.id"
              >
                {{ nation_item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="籍贯">
            <a-cascader
              v-decorator="[
                'nation_place',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择籍贯!',
                    },
                  ],
                },
              ]"
              :options="nationOptions"
              :load-data="loadNation"
              placeholder="请选择"
              change-on-select
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="出生日期">
        <a-date-picker
          valueFormat="YYYY-MM-DD"
          v-decorator="[
            'birthday',
            {
              rules: [
                {
                  required: true,
                  message: '请选择生日!',
                },
              ],
            },
          ]"
          :locale="locale"
        />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="身份证号">
            <a-input
              style="width: 400px"
              v-decorator="[
                'idcard',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入身份证号!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="电话号码">
            <a-input
              style="width: 400px"
              v-decorator="[
                'mobile',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入电话号码!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="电子邮箱">
        <a-input
          style="width: 400px"
          v-decorator="[
            'email',
            {
              rules: [
                {
                  required: true,
                  message: '请输入电子邮箱!',
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="入会时间">
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-decorator="[
                'join_time',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择入会时间!',
                    },
                  ],
                },
              ]"
              :locale="locale"
            />
          </a-form-item>
        </a-col>

       <!-- <a-col :span="12">
          <a-form-item label="行业类型">
            <a-select
              v-decorator="[
                'cate_id',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择行业类型!',
                    },
                  ],
                },
              ]"
              style="width: 240px"
            >
              <a-select-option
                v-for="(industry_item, industry_index) in industry"
                :key="industry_index"
                :value="industry_item.id"
              >
                {{ industry_item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-item label="艺术门类">
           <!-- <a-select
              placeholder="请选择"
              style="width: 238px"
              mode="multiple"
              v-decorator="[
                'artValue',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择艺术门类!',
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(art_item, art_index) in artOptions"
                :key="art_index"
                :value="art_item.id"
              >
                {{ art_item.name }}
              </a-select-option>
            </a-select> -->
			 <a-tree-select
			    show-search
			    style="width: 238px"
			    :show-checked-strategy="SHOW_ALL"
			    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
			    placeholder="请选择艺术门类"
			    :allow-clear="false"
			    multiple
			    @change="onChange"
			    @select="onSelect"
				 :tree-data="artOptions"
				 tree-checkable
				 
				v-decorator="[
				  'artValue',
				  {
				    rules: [
				      {
				        required: true,
				        message: '请选择艺术门类!',
				      },
				    ],
				  },
				]"
			  >
			   <!-- <a-tree-select-node v-for="(item,index) in artOptions" :key="index" :value="item.id" :title="item.name">
			        <a-tree-select-node v-for="(i,inx) in item.son_art" :value="i.id" :title="i.name">
			        </a-tree-select-node>
			    </a-tree-select-node> -->
			  </a-tree-select>
          </a-form-item>
        </a-col>
		
		
        <a-col :span="6">
          <a-form-item label="现所在地">
            <a-cascader
              v-decorator="[
                'addressValue',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择现所在地!',
                    },
                  ],
                },
              ]"
              :options="areaOptions"
              :load-data="loadArea"
              placeholder="请选择"
              change-on-select
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- <a-row>
        <a-col :span="12">
          <a-form-item label="已选艺术门类" class="artTag">
            <div
              style="
                background-color: #c03838;
                color: white;
                padding: 0 20px 0 10px;
                margin-right: 10px;
              "
              v-for="(art_item, art_index) in artList"
              :key="art_index"
            >
              {{ art_item.name }}
              <img
                @click="deleteArt(art_item.name)"
                style="width: 18px; height: 18px; cursor: pointer"
                src="../../assets/images/match/bm-bt-delete@2x.png"
                alt=""
              />
            </div>
          </a-form-item>
        </a-col>
      </a-row> -->

      <a-row>
        <a-col :span="12">
          <a-form-item label="微博号">
            <a-input
              style="width: 400px"
              v-decorator="[
                'weibo',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入微博号!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="微信号">
            <a-input
              style="width: 400px"
              v-decorator="[
                'weixin',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入微信号!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="办公地址">
        <a-input
          style="width: 1000px"
          v-decorator="[
            'address',
            {
              rules: [
                {
                  required: true,
                  message: '请输入办公地址!',
                },
              ],
            },
          ]"
        />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="行政职务">
            <a-input
              style="width: 400px"
              v-decorator="[
                'xz_job',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入行政职务!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
         <a-form-item label="文艺职务">
           <a-select
             v-decorator="[
               'wl_job',
               {
                 rules: [
                   {
                     required: true,
                     message: '请选择文艺职务!',
                   },
                 ],
               },
             ]"
             style="width: 240px"
           >
             <a-select-option
               v-for="(item_job, index_job) in job_list"
               :key="index_job"
               :value="item_job.id"
             >
               {{ item_job.name }}
             </a-select-option>
           </a-select>
         </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-item label="协会职位">
            <a-input
              style="width: 400px"
              v-decorator="[
                'xh_job',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入协会职位!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="8">
          <a-form-item label="所在协会">
            <a-select style="width: 240px">
              <a-select-option value="jack"> Jack </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
      </a-row>

      <a-form-item label="个人简历">
        <a-textarea
          v-decorator="[
            'synopsis',
            {
              rules: [
                {
                  required: true,
                  message: '请输入简历!',
                },
              ],
            },
          ]"
          placeholder="请输入您的个人简历或艺术简历"
          :auto-size="{ minRows: 8 }"
        />
      </a-form-item>
    </a-form>

    <div class="btns">
      <img
        @click="submit"
        src="../../assets/images/expert/button-save@2x.png"
        alt=""
      />
      <img
        @click="reset"
        src="../../assets/images/expert/button-clear@2x.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import {getJobList} from "../../xx-vue/services/job";
import SystemServices from "../../xx-vue/services/system";
import ExpertsServices from "../../xx-vue/services/expert";
import Storage from "../../xx-vue/utils/storage";
import UserServices from "../../xx-vue/services/user";
import { TreeSelect } from 'ant-design-vue';
const SHOW_ALL = TreeSelect.SHOW_ALL;

export default {
  data() {
    return {
		SHOW_ALL,
      img_avatar_full: "",
      img_avatar: "",
      nationOptions: [], //籍贯一级
      artsOptions: [],
      areaOptions: [],
      locale: {
        //日期中文
        lang: {
          placeholder: "请选择日期",
          today: "今天",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
        },
      },
      nation: [], //民族
      // artList: [],
      artOptions: [],
      industry: [],
	  job_list:{},
	  "choosed_arts":[1,2]
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "applyForm" });
  },
  mounted() {
    this.initData();
	this.getJobData();
  },
  methods: {
	  onChange(value) {
	        console.log(value);
	        // this.value = value;
	  },
	  onSearch() {
		// console.log(...arguments);
	  },
	  onSelect(value, node, extra) {
		  if(!node.checked){
			  console.log("isrun");
			  node.$parent = true;
		  }
		  // console.log(value, node, extra);
		//   console.log(1);
		// console.log(...arguments);
	  },
    beforeUpload(file) {
      console.log(file);
    },
    //限制名字
    notNum(rule, value, callback) {
      const name = /^[0-9]*$/;
      if (name.test(value)) {
        callback(new Error("姓名不能为数字"));
      } else {
        callback();
      }
    },
	//获取文艺数据
	getJobData(){
		getJobList().then(api_res=>{
			this.job_list = api_res.data.data_list;
		}).catch(err=>{});
	},
    //懒加载籍贯
    loadNation(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const pid = targetOption.id;
      targetOption.loading = true;
      // 懒加载请求
      setTimeout(async () => {
        targetOption.loading = false;
        let result = await SystemServices.getAreaAsync({ pid: pid });
        let data = result.data.list;
        data = data.map((v) => {
          return { ...v, value: v.id, label: v.name, isLeaf: v.hasChildren };
        });
        targetOption.children = data;
        this.nationOptions = [...this.nationOptions];
      }, 100);
    },
    //懒加载艺术门类
    // loadArts(selectedOptions) {
    //   const targetOption = selectedOptions[selectedOptions.length - 1];
    //   const pid = targetOption.id;
    //   targetOption.loading = true;
    //   // 懒加载请求
    //   setTimeout(async () => {
    //     targetOption.loading = false;
    //     let result = await SystemServices.getArtAsync({ pid: pid });
    //     // console.log(targetOption);
    //     let data = result.data.data;
    //     data = data.map((v) => {
    //       return {
    //         ...v,
    //         value: v.id,
    //         label: v.name,
    //         isLeaf: !v.hasChildren,
    //       };
    //     });
    //     targetOption.children = data;
    //     this.artsOptions = [...this.artsOptions];
    //   }, 100);
    // },
    //懒加载区域
    loadArea(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const pid = targetOption.id;
      targetOption.loading = true;
      // 懒加载请求
      setTimeout(async () => {
        targetOption.loading = false;
        let result = await SystemServices.getAreaAsync({ pid: pid });
        // console.log(targetOption);
        let data = result.data.list;
        const isLeaf = targetOption.level < 2 ? false : true;
        data = data.map((v) => {
          return {
            ...v,
            value: v.id,
            label: v.name,
            isLeaf: isLeaf,
          };
        });
        targetOption.children = data;
        this.areaOptions = [...this.areaOptions];
      }, 100);
    },
    //表单提交
    submit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values.province_id = values.addressValue[0];
          values.city_id = values.addressValue[1];
          values.district_id = values.addressValue[2];
		  values.art_status = 1;
          // delete values.addressValue;
          // delete values.artValue;

          // let artStr = "";
          // this.artList.map((v, i) => {
          //   if (i !== this.artList.length - 1) {
          //     artStr += v.value + ",";
          //   } else {
          //     artStr += v.value;
          //   }
          // });

          values.art_category = artStr;
          let artStr = "";
          values.artValue.map((v, i) => {
            if (i !== values.artValue.length - 1) {
              artStr += v + ",";
            } else {
              artStr += v;
            }
          });
          

          values.art_category = artStr;
          const nationLth = values.nation_place.length - 1;
          values.nation_place = values.nation_place[nationLth];
          values.img_avatar = this.img_avatar;
          const result = await ExpertsServices.addExpertAsync(values);
          if (result.code === 200) {
            this.$message.success("申请成功，请等待审核通过");
            const userInfo = await UserServices.getCurrentUserAsync();
            const storage = Storage.getStorage();
            storage.info = userInfo.data;
            Storage.setStorage(storage);
            setTimeout(() => {
              location.reload();
            }, 500);
          }
        }
      });
    },
    //初始化下拉框数据
    async initData() {
      const nation = await SystemServices.getNationAsync();
      this.nation = nation.data.data;
      const nation_place = await SystemServices.getAreaAsync();
      let artOptions = await SystemServices.getArtAsync({ pid: 0 });
      this.artOptions = (artOptions.data.data || []). map(item=>{
		  var d = {
				  title	: item.name,
			      value	: item.id,
			      key	: item.id,
		  };
		  d['children'] = item.son_art.map(item_c=>{
			  var d_c = {
				      title	: item_c.name,
				      value	: item_c.id,
				      key	: item_c.id,
			  };
			  return d_c;
		  })
		  return d;
	  });

      this.nationOptions = nation_place.data.list.map((v) => {
        return { ...v, value: v.id, label: v.name, isLeaf: !v.hasChildren };
      });

      this.areaOptions = nation_place.data.list.map((v) => {
        return { ...v, value: v.id, label: v.name, isLeaf: !v.hasChildren };
      });

      const art = await SystemServices.getArtAsync({ pid: 0 });
      this.artsOptions = art.data.data.map((v) => {
        return { ...v, value: v.id, label: v.name, isLeaf: !v.hasChildren };
      });

      const industry = await SystemServices.getIndustryAsync();
      this.industry = industry.data.data;
    },
    //重置表单
    reset() {
      this.form.resetFields();
    },
    //上传头像
    async uploadHeadPic(obj) {
      const formData = new FormData();
      formData.append("file", obj.file);
      const result = await SystemServices.uploadPicAsync(formData);
      this.img_avatar = result.data.path;
      this.img_avatar_full = result.data.path_full;
    },
    // addArt(value, selectedOptions) {
    //   if (selectedOptions.length % 2 === 0) {
    //     const name = selectedOptions[0].name + "/" + selectedOptions[1].name;
    //     this.artList = this.artList.filter((v) => v.name !== name);
    //     this.artList.push({ name: name, value: value[1] });
    //     console.log(this.artList);
    //   }
    // },
    // deleteArt(item) {
    //   this.artList = this.artList.filter((v) => v.name !== item);
    // },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-select-selection__placeholder {
  font-size: 20px;
}
/deep/ .ant-form-item label {
  color: #656565;
}
/deep/ .ant-upload.ant-upload-select-picture-card {
  background-color: unset;
  border: none;
}
/deep/ textarea.ant-input {
  width: 1000px;
  resize: none;
}

/deep/ .artTag .ant-form-item-children {
  display: flex;
}

/deep/ .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/ .ant-upload-picture-card-wrapper {
  width: 135px;
}
/deep/ .ant-input {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .has-error .ant-input {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .has-error .ant-input,
.has-error .ant-input:hover {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .ant-select-selection--single {
  color: #989898;
  height: unset;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}

/deep/ .ant-cascader-picker {
  border: 1px solid #e6e7e8;
  width: 240px;
  color: #989898;
}

/deep/ .ant-calendar-picker-input.ant-input {
  width: 240px;
  background-color: white;
  border: 1px solid #e6e7e8;
}

/deep/ .ant-form-item-label {
  text-align: center;
  min-width: 90px;
}
.body {
  border: 1px solid #e6e7e8;
  .title {
    padding-left: 36px;
    padding-top: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    border-bottom: 2px solid #e6e7e8;
    margin-bottom: 50px;
    div {
      display: inline-block;
      padding-bottom: 10px;
      border-bottom: 2px solid #e24141;
    }
  }

  .form {
    padding: 0 22px;
    .notChoose {
      width: 100px;
      height: 140px;
    }
    .ant-form-item {
      display: flex;
      align-items: center;
    }
  }

  .btns {
    width: 400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 42px;
    img {
      width: 146px;
      height: 56px;
      cursor: pointer;
    }
  }
}
</style>